// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileconfigLinkController from "./mobileconfig_link_controller"
application.register("mobileconfig-link", MobileconfigLinkController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)
